// styling
import styles from './style.module.scss';
// components
import Spring from '@components/Spring';
// assets
import classNames from 'classnames';

const Features = () => {
    const data = [
        { label: 'Complete Compositions Of Sequential Works By The Panel', },
        { label: 'Pre-Production, Production & Post-production Features', },
        { label: 'Third-Party Sharing Integration', },
        { label: 'Audience Engagement', },
        { label: 'Community Support & Education', },
        { label: 'Sponsorship & Publication Opportunities', },
    ];

    return (
        <section className={styles.section}>
            {/* <img className={styles.shape} src={shape} alt="media" /> */}
            <div className={`${styles.container} container`}>
                <div className="d-flex flex-column g-10">
                    <p className={styles.pPlat}>FEATURES</p>
                    <p className={styles.pPlatText}>
                        Main <span className={styles.pPlatTextSpan}>Features</span> Of Our Platform Includes:
                    </p>
                </div>
                <div className={styles.main}>
                    {
                        data.map((item, index) => (
                            <Spring key={index} index={index}>
                                <div className={`${styles.main_item} d-flex flex-column g-10 border-10 bg-secondary`}>
                                    <p className={classNames('h6', styles.label)}>
                                        <span className={styles.serial}>{index + 1}.</span>&nbsp;{item.label}
                                    </p>
                                </div>
                            </Spring>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default Features